export default __webpack_public_path__ + "static/media/startup-sound.eb046177.wav";